import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hiddenFilter',
  pure: false

})
export class HiddenFilterPipe implements PipeTransform {
  transform(items, paceEnabled: boolean): any {
    if (!items || !paceEnabled) {
           return items;
       }
    return paceEnabled?items.filter(item=>{return item['paceAction']!='HIDE'}):items;
  }

}
